import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import StorageIcon from '@mui/icons-material/Storage';
import ChatContext from '../contexts/chatContext';
import { ADMIN_ROLE } from '../constants';
import AddChatButton from './AddChatButton';
import UserRoleCheck from './UserRoleCheck';
import Menu from './Menu';
import EditChatNameButton from './EditChatNameButton';
import DeleteChatButton from './DeleteChatButton';
var API_TOOLTIP_MAP = {
    chatgpt: 'ChatGPT',
    gemini: 'Gemini',
    qwen: 'Qwen'
};
var MainMenu = function (_a) {
    var chats = _a.chats, dispatch = _a.dispatch;
    var chat = useContext(ChatContext).chat;
    if (!chat) {
        return _jsx(_Fragment, {});
    }
    var handleSelectChat = function (_, id) {
        return dispatch({
            state: {
                selectedChatId: id
            },
            type: 'select_chat'
        });
    };
    var header = _jsx(AddChatButton, { chats: chats, dispatch: dispatch });
    var footer = (_jsxs(_Fragment, { children: [_jsx(UserRoleCheck, { roles: [ADMIN_ROLE], children: _jsx(Button, { variant: "outlined", component: Link, startIcon: _jsx(AdminPanelSettingsIcon, {}), to: "/admin", sx: { ml: 2, mr: 2, mt: 2 }, children: "Admin panel" }) }), _jsx(Button, { variant: "outlined", component: Link, startIcon: _jsx(StorageIcon, {}), to: "/datasources", sx: { ml: 2, mr: 2, mt: 2 }, children: "Data sources" })] }));
    return (_jsx(Menu, { header: header, footer: footer, children: _jsx(Tabs, { value: chat.id, onChange: handleSelectChat, orientation: "vertical", variant: "scrollable", scrollButtons: false, sx: { flexGrow: 1 }, children: chats.map(function (c) {
                var _a;
                return (_jsx(Tab, { value: c.id, label: _jsxs(Box, { display: "flex", alignItems: "center", width: "100%", children: [_jsx(Tooltip, { title: c.name, children: _jsx(Box, { flexGrow: 1, textAlign: "left", sx: { overflow: 'hidden', textOverflow: 'ellipsis', textTransform: 'none', whiteSpace: 'nowrap' }, children: c.name }) }), _jsx(Tooltip, { title: API_TOOLTIP_MAP[c.api || 'chatgpt'], children: _jsx(Avatar, { sx: { height: 24, width: 24 }, children: (_a = API_TOOLTIP_MAP[c.api || 'chatgpt']) === null || _a === void 0 ? void 0 : _a[0] }) }), _jsx(EditChatNameButton, { chat: c, dispatch: dispatch }), _jsx(DeleteChatButton, { chat: c, dispatch: dispatch })] }) }, c.id));
            }) }) }));
};
export default MainMenu;
